import React from 'react';
import ContainerTemplate from '../../../widgets/template/Container';
import EntAjustesView from './EntAjustesView';
import * as ROUTES from '../../../router/Routes';

const EntAjustesModule = () => {
  return (
    <ContainerTemplate active={ROUTES.ajustes} routes={[]}>
      <EntAjustesView />
    </ContainerTemplate>
  );
};

export default EntAjustesModule;
